import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';

export default {
    name: 'fellowDashboard',
    components: {
        InfiniteLoading,
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            fellows: [],
            dashboardFellows: [],
            fellowDistricts: [],
            skip: 0,
            take: 5,
            district: ''
        }
    },
    methods: {
        initialize() {
            let vm = this;

            return vm.getFellows()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.fellows = res.data;
                        vm.createDashboardFellows();
                        // vm.showFellowLocationsOnMap();
                    }
                    return res;
                })
                .then(function () {
                    return vm.getFellowDistricts()
                })
                .then(function (res) {
                    if (res.data) {
                        vm.fellowDistricts = res.data;
                        vm.highlightFellowDistricts()
                    }
                    return res
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        highlightFellowDistricts() {
            let vm = this;
            let individualCountrySettings = [];
            for (let fellowDistrict of vm.fellowDistricts) {
                let individualStateSetting = {
                    name: `${fellowDistrict.toLowerCase()}_1_`,
                    color: "yellow",
                    hoverColor: "orange",
                    border: "black",
                    borderWidth: 5
                }
                individualCountrySettings.push(individualStateSetting);
            }
            $('#mh-map').twism("create",
                {
                    map: "custom",
                    color: "#a3d0ef",
                    hoverColor: "#89c3ea",
                    backgroundColor: "white",
                    border: "black",
                    click: function (country) {
                    },
                    individualCountrySettings: individualCountrySettings
                });
        },
        showFellowLocationsOnMap() {
            let vm = this;
            let map = null;

            let markers = []
            for (let fellow of vm.fellows) {
                if (fellow.posting.location.coordinates) {


                    let fellowCenter = new google.maps.LatLng(fellow.posting.location.coordinates[0], fellow.posting.location.coordinates[1]);
                    let fellowMarker = new google.maps.Marker({ position: fellowCenter });
                    let displayString = '<font size="1">' + fellow.candidateName + '(' + fellow.candidateCode + ') <br>' + fellow.posting.assignedGP.name + '</font>'
                    let fellowInfowindow = new google.maps.InfoWindow({
                        content: displayString
                    });

                    if (!map) {
                        let mapCanvas = document.getElementById("fellowsMap");
                        let mapOptions = { center: fellowCenter, zoom: 6 };
                        map = new google.maps.Map(mapCanvas, mapOptions);
                    }

                    fellowMarker.setMap(map);
                    fellowInfowindow.open(map, fellowMarker);

                    google.maps.event.addListener(fellowMarker, 'click', function () {
                        if (fellowInfowindow.getMap()) {
                            fellowInfowindow.close(map, fellowMarker);
                        } else {
                            fellowInfowindow.open(map, fellowMarker);
                        }
                    });
                }
            }
        },
        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getFellows()
                .then(function (res) {

                    vm.fellows = vm.fellows.concat(res.data);
                    vm.createDashboardFellows();
                    // vm.showFellowLocationsOnMap();
                    $state.loaded();

                    if (res.data.length === 0) {
                        $state.complete()
                    }
                    return res

                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        createDashboardFellows() {
            let vm = this;
            vm.dashboardFellows = [];
            for (let i = 0; i < vm.fellows.length; i += 2) {
                let arr = [];
                arr.push(vm.fellows[i]);
                arr.push(vm.fellows[i + 1]);
                // arr.push(vm.fellows[i + 2]);
                vm.dashboardFellows.push(arr);
            }
        },
        getFellows() {
            let vm = this;
            return axiosCommon.get(`o/fellows?skip=${vm.skip}&take=${vm.take}&district=${vm.district}`)
        },
        getFellowDistricts() {
            let vm = this;
            return axiosCommon.get(`o/fellows/districts`)
        },
        fetchFellowsByDistrict(district) {
            let vm = this;
            vm.skip = 0;
            vm.district = district;
            vm.getFellows().then(function (res) {
                vm.fellows = res.data;
                vm.createDashboardFellows();
            }).catch(function (err) {
                console.log(err);
                return err;
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/fellow-dashboard/fellow-dashboard.js